module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M10.624 8H14v9c0 .55.462 1 1.016 1h2c.552 0 .984-.45.984-1V8h3.406c.594 0 .788-.53.43-1L16.662.356c-.358-.47-.936-.478-1.292-.008L10.196 7c-.358.472-.164 1 .428 1zM22 17c0 .552.462 1 1.016 1H28v6H4v-6h5.016A.987.987 0 0 0 10 17v-2c0-.552-.432-1-.984-1h-7A2.012 2.012 0 0 0 0 16v14c0 1.106.91 2 2.016 2h28A1.985 1.985 0 0 0 32 30V16c0-1.106-.878-2-1.984-2h-7c-.554 0-1.016.448-1.016 1v2z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/upload-1.js
// module id = 1481
// module chunks = 14